import { render, staticRenderFns } from "./pricetotal.vue?vue&type=template&id=64686aaa&"
import script from "./pricetotal.vue?vue&type=script&lang=js&"
export * from "./pricetotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64686aaa')) {
      api.createRecord('64686aaa', component.options)
    } else {
      api.reload('64686aaa', component.options)
    }
    module.hot.accept("./pricetotal.vue?vue&type=template&id=64686aaa&", function () {
      api.rerender('64686aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2U68jTbBYXdgG/JS/comp/pricetotal.vue"
export default component.exports